const railRetryLabel = {
  fontWeight: 590,
  lineHeight: '20px',
  color: 'text.primary',
}

export const muiComponentsButtonVariants = {
  MuiButton: {
    variants: [
      {
        props: { variant: 'railRetryNews' },
        style: {
          marginTop: 4,
          padding: '4px 12px',
          minWidth: 'auto',
          textTransform: 'none',
          borderRadius: '9999px',
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: 'background.paper',
          boxShadow: 'none',
          ...railRetryLabel,
          '&:hover': { backgroundColor: 'action.hover', boxShadow: 'none' },
        },
      },
    ],
  },
}
